// extracted by mini-css-extract-plugin
module.exports = {"intro":"styles_intro__3m7UN","name":"styles_name__1NC9q","number":"styles_number__tj_We","action":"styles_action__3t3DO"};